import type { Distance, Pixel } from "@pdfking/math"
import { Divide } from "@pdfking/math"
import { RecordMap } from "@pdfking/tfunc"

export const ConvertPixels = <T extends Record<string, Pixel>>(
  options: { unit_to_px: Pixel },
  rect: T
): { [K in keyof T]: Distance } =>
  RecordMap(v => Divide<Pixel>(v, options.unit_to_px) as number as Distance, rect)
